<template>
  <base-material-card
    :icon="icon"
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:after-heading>
      <div class="ml-auto text-right">
        <div
          class="body-3 black--text font-weight-light"
          v-text="title"
        />

        <h3 style="font-size: 1.863rem;" class="font-weight-regular text--primary">
          {{ value }} <small>{{ smallValue }}</small>
        </h3>
      </div>
    </template>

    <v-col
      cols="12"
      class="px-0"
    >
      <template v-if="data1">
        <v-row class="py-2">
          <v-col
            cols="8"
            class="body-3 grey--text font-weight-light"
            v-text="data1"
          />
          <v-col
            cols="4"
            class="body-1 font-weight-light text--primary text-right">
            {{ data1Value }}
          </v-col>
        </v-row>
      </template>
      <template v-if="data2">
        <v-divider />
        <v-row class="py-2">
          <v-col
            cols="8"
            class="body-3 grey--text font-weight-light"
            v-text="data2"
          />
          <v-col
            cols="4"
            class="body-1 font-weight-light text--primary text-right">
            {{ data2Value }}
          </v-col>
        </v-row>
      </template>
      <template v-if="data3">
        <v-divider />
        <v-row class="py-2">
          <v-col
            cols="8"
            class="body-3 grey--text font-weight-light"
            v-text="data3"
          />
          <v-col
            cols="4"
            class="body-1 font-weight-light text--primary text-right">
            {{ data3Value }}
          </v-col>
        </v-row>
      </template>
      <v-divider />
    </v-col>

    <v-icon
      :color="subIconColor"
      size="16"
      class="ml-2 mr-1"
    >
      {{ subIcon }}
    </v-icon>

    <span
      :class="subTextColor"
      class="caption grey--text font-weight-light"
      v-text="subText"
    />
  </base-material-card>
</template>

<script>
  import Card from './Card'

  export default {
    name: 'MaterialStatsCard',

    inheritAttrs: false,

    props: {
      ...Card.props,
      icon: {
        type: String,
        required: true,
      },
      subIcon: {
        type: String,
        default: undefined,
      },
      subIconColor: {
        type: String,
        default: undefined,
      },
      subTextColor: {
        type: String,
        default: undefined,
      },
      subText: {
        type: String,
        default: undefined,
      },
      title: {
        type: String,
        default: undefined,
      },
      value: {
        type: String,
        default: undefined,
      },
      smallValue: {
        type: String,
        default: undefined,
      },
      data1: {
        type: String,
        default: undefined,
      },
      data1Value: {
        type: String,
        default: undefined,
      },
      data2: {
        type: String,
        default: undefined,
      },
      data2Value: {
        type: String,
        default: undefined,
      },
      data3: {
        type: String,
        default: undefined,
      },
      data3Value: {
        type: String,
        default: undefined,
      },
    },
  }
</script>

<style lang="sass">
.v-card--material-stats
  display: flex
  flex-wrap: wrap
  position: relative

  > div:first-child
    justify-content: space-between

  .v-card
    border-radius: 4px
    flex: 0 1 auto

  .v-card__text
    display: inline-block
    flex: 1 0 calc(100% - 120px)
    position: absolute
    top: 0
    right: 0
    width: 100%

  .v-card__actions
    flex: 1 0 100%
</style>
